import { version } from '../package.json';

const {
  VITE_API_SERVICE_URI,
  VITE_ENVIRONMENT,
  VITE_APP_URL,
  VITE_AI_API_SERVICE_URI,
} = import.meta.env;

export default {
  app: {
    version,
    environment: VITE_ENVIRONMENT,
    appUrl: VITE_APP_URL,
  },
  api: {
    host: VITE_API_SERVICE_URI,
  },
  ai: {
    host: VITE_AI_API_SERVICE_URI,
  },
};
